import React, { useState, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";

const images = [
  "/images/farzad_slide-1.jpg",
  "/images/farzad_slide-2.jpg",
  "/images/farzad_slide-3.jpg",
  "/images/farzad_slide-4.jpg"
];

const CardLayout = () => {
  const { t } = useTranslation();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); 
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFade(true);
      }, 200);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
    <div className="flex-layout">
      <section className="flex-container section-1" aria-labelledby="section1">      
        <div className="grid-item item1">
          <div className="card-1-container">
            <div className="content">
              <p className="bullet">{t("card1.subtitle")}</p>
              <h2 id="section1">
              <Trans i18nKey="card1.title">
              Stay ahead of  <span className="highlight">your goals</span> by accelerating
              </Trans>
              </h2>
            </div>
            <div className="card-1-image">
              <img src="/images/card_1_chess.svg" alt="Chessboard and pieces representing strategy" className="chess" />
            </div>
          </div>
        </div>
        <div className="grid-item item5">
          <div className="card-5-container">
            <div className="content">
              <p className="bullet">{t("card4.subtitle")}</p>
              <h2>
                {/* INVENTOR
                <br /> */}
                <span>{t("card4.title1")}</span>
                <br />
                {t("card4.title2")}
                <br />
                <span>{t("card4.title3")}</span>
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section className="flex-container section-2" aria-labelledby="section2">
        <div className="grid-item item2">
          <div className="card-2-container">
            <div className="content">
              <h3>{t("card2.title")}</h3>
            </div>
          </div>
        </div>
      <div className="grid-item item3">
        <div className="card-image-container">
          <img
            src={images[currentImageIndex]}
            alt="Farzad showcasing professional images"
            className={`slide ${fade ? "fade-in" : "fade-out"}`}
          />
        </div>
      </div>
      <div className="grid-item item4">
        <div className="card-4-container">
          <div className="content">
            <h3>
            <Trans i18nKey="card3.title">
            Get in touch for <span className="highlight">consultation</span> today!
              </Trans>
            </h3>
            <button className="btn-outline" aria-label={t("card3.btn")} onClick={() => window.location.hash = '#contact'}>{t("card3.btn")}</button>
          </div>
        </div>
      </div>
      </section>
    </div>
    </>
  );
};

export default CardLayout;
